import React, { forwardRef } from 'react';
import cn from 'classnames';
import { LIGHT_LINKS, DARK_LINKS } from './classnames';
import { getDefaultIconValues, IconItemType } from '../helpers';
import { TextLinkProps } from './types';

const TextLink = forwardRef<any, TextLinkProps>(
  (
    {
      children,
      label,
      type = 'level1',
      htmlType,
      as,
      href,
      leftIcon: leftIconProp,
      rightIcon: rightIconProp,
      className = '',
      darkMode,
      ...other
    },
    ref,
  ) => {
    const textLinkClassNames = cn(
      darkMode ? DARK_LINKS[type] : LIGHT_LINKS[type],
      className,
    );
    const leftIcon: IconItemType = getDefaultIconValues(leftIconProp, 24);
    const rightIcon: IconItemType = getDefaultIconValues(rightIconProp, 24);
    let Tag: keyof JSX.IntrinsicElements = 'button';

    if (as) {
      Tag = as;
    } else if (href) {
      Tag = 'a';
    }

    if (leftIcon.component || rightIcon.component) {
      return (
        <Tag
          className={textLinkClassNames}
          href={href}
          type={Tag === 'button' ? htmlType : undefined}
          ref={ref}
          {...other}
        >
          {leftIcon.component && (
            <leftIcon.component
              size={leftIcon.size}
              className={cn(
                {
                  'fill-current': leftIcon.hasFill,
                  'stroke-current': leftIcon.hasStroke,
                  'mr-8': label || children,
                },
                'flex-shrink-0',
              )}
              ignoreColor
            />
          )}
          {label || children}
          {rightIcon.component && (
            <rightIcon.component
              size={rightIcon.size}
              className={cn(
                {
                  'fill-current': rightIcon.hasFill,
                  'stroke-current': rightIcon.hasStroke,
                  'ml-8': label || children,
                },
                'flex-shrink-0',
              )}
              ignoreColor
            />
          )}
        </Tag>
      );
    }

    return (
      <Tag
        className={textLinkClassNames}
        href={href}
        type={Tag === 'button' ? htmlType : undefined}
        ref={ref}
        {...other}
      >
        {label || children}
      </Tag>
    );
  },
);

export default TextLink;
